import React from 'react';
import Header from './header';
import Footer from './footer';
import WidgetContact from '../../components/Widgets/widget-contact';
import OpalineFooter from '../Opaline/Opaline-footer';

export default function Layout({ children, showOpaline = false }) {
    return (
        <div>
            <Header />
            <main>{children}</main>
            <WidgetContact />
            {showOpaline && <OpalineFooter />}
            <Footer />
        </div>
    );
};
